<div class="tveyes-mediaview-dialog">
    <agpr-button
        class="tveyes-mediaview-focusClose"
        [style]="buttonTypesEnum.icon"
        icon="agpr-i-close"
        tooltip="close"
        tooltipPosition="top"
        (click)="close()"
    ></agpr-button>
    <agpr-dialog-container
        [id]="id"
        class="tveyes-mediaview-dialogContainer"
        [heading]="mention?.headline ?? 'Mention.tveyes.mediaview.loadingMention'"
        [showClose]="false"
        (close)="close()"
        [contentPadding]="false"
    >
        <div class="tveyes-mediaview-content">
            <agpr-scroll-panel class="tveyes-mediaview-scrollPanel">
                <agpr-iframe-dialog
                    #iframe
                    [id]="id + '_tvEyes_mediaview_iframe'"
                    class="tveyes-mediaview-iframe"
                    [showOverlay]="false"
                    [showClose]="false"
                    [url]="currentMediaviewUrl"
                    [heading]="mediaviewIFrameSettings.inputs.heading"
                    [frameWidth]="'100%'"
                    [frameHeight]="'100%'"
                    (message)="handleIframeMessage($event)"
                ></agpr-iframe-dialog>
            </agpr-scroll-panel>
        </div>
        <div class="tveyes-mediaview-timeline"
            *ngIf="showTimeline()"
        >
            <agpr-button
                class="tveyes-mediaview-timeline-arrow tveyes-mediaview-timeline-arrowLeft"
                [style]="buttonTypesEnum.icon"
                icon="fa-solid fa-chevron-left"
                [disabled]="currentTimelinePage() < -9"
                [tooltip]="currentTimelinePage() < -9
                    ? 'Mention.tveyes.mediaview.timeline.back.disabled'
                    : 'Mention.tveyes.mediaview.timeline.back'"
                tooltipPosition="top"
                (click)="scrollTimeline('back')"
            ></agpr-button>

            <div
                class="tveyes-mediaview-timeline-thumbnails"
                [agprLoading]="timelineLoading()"
            >
                <div
                    *ngFor="let thumbnail of timelineThumbnails()"
                    class="tveyes-mediaview-timeline-thumbnail"
                >
                    <div
                        *ngIf="mention.mediaType.id !== mediaTypeEnum.RADIO"
                        class="tveyes-mediaview-timeline-thumbnail-content"
                    >
                        <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -->
                        <div
                            class="tveyes-mediaview-timeline-thumbnail-img-btn"
                            (click)="postWindowMessage('setPlayhead', thumbnail.datetime)"
                        >
                        <img

                            class="tveyes-mediaview-timeline-thumbnail-img"
                            [src]="thumbnail.url" [alt]="'Timeline thumbnail for' + thumbnail.datetime"
                            aria-hidden="true"
                        />
                        </div>
                        <div class="tveyes-mediaview-timeline-thumbnail-datetime">
                            {{ thumbnail.datetime | date:'hh:mm:ss a' : 'UTC' }}
                        </div>
                    </div>
                    <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -->
                    <div
                        *ngIf="mention.mediaType.id === mediaTypeEnum.RADIO"
                        class="tveyes-mediaview-timeline-thumbnail-radio"
                        (click)="postWindowMessage('setPlayhead', thumbnail.datetime)"
                    >
                        <div class="tveyes-mediaview-timeline-thumbnail-datetime">
                            {{ thumbnail.datetime | date:'hh:mm:ss a' : 'UTC' }}
                        </div>
                    </div>

                    <!-- Context Menu -->
                    <div class="tveyes-mediaview-timeline-thumbnail-contextMenu">
                        <agpr-button
                            class="tveyes-mediaview-timeline-thumbnail-contextMenu-button"
                            [icon]="'fa-regular fa-arrow-left-to-line'"
                            [style]="buttonTypesEnum.contextMenu"
                            tooltip="Mention.tveyes.mediaview.timeline.setStartTime"
                            tooltipPosition="top"
                            (click)="postWindowMessage('setStartPoint', thumbnail.datetime)"
                        ></agpr-button>
                        <agpr-button
                            class="tveyes-mediaview-timeline-thumbnail-contextMenu-button"
                            [icon]="'fa-regular fa-arrow-right-to-line'"
                            [style]="buttonTypesEnum.contextMenu"
                            tooltip="Mention.tveyes.mediaview.timeline.setEndTime"
                            tooltipPosition="top"
                            (click)="postWindowMessage('setEndPoint', thumbnail.datetime)"
                        ></agpr-button>
                    </div>
                </div>
            </div>

            <agpr-button
                class="tveyes-mediaview-timeline-arrow tveyes-mediaview-timeline-arrowRight"
                [style]="buttonTypesEnum.icon"
                icon="fa-solid fa-chevron-right"
                [disabled]="currentTimelinePage() > 9"
                [tooltip]="currentTimelinePage() > 9
                    ? 'Mention.tveyes.mediaview.timeline.forward.disabled'
                    : 'Mention.tveyes.mediaview.timeline.forward'"
                tooltipPosition="top"
                (click)="scrollTimeline('forward')"
            ></agpr-button>
        </div>
        <ng-template #footerLeft>
            <agpr-button
                [id]="id + '_show_hide_timeline_btn'"
                [label]="showTimeline() ? 'Mention.tveyes.mediaview.timeline.hide' : 'Mention.tveyes.mediaview.timeline.show'"
                [disabled]="disableTimeline() !== null"
                [tooltip]="disableTimeline() === disableTimelineReason.LOADING_MENTION
                    ? 'Mention.tveyes.mediaview.loadingMention'
                    : disableTimeline() === disableTimelineReason.UNSAVED_MENTION
                    ? 'Mention.tveyes.mediaview.timeline.disabled.unsaved'
                    : disableTimeline() === disableTimelineReason.EDITED_MENTION
                    ? 'Mention.tveyes.mediaview.timeline.disabled.editedArchived'
                    : null"
                (click)="toggleTimeline()"
                [style]="buttonTypesEnum.secondary"
            ></agpr-button>
        </ng-template>
        <ng-template #footerRight>
            @if (enablePrecisionClip && hasPrecisionClipPermission && mention.isPrecisionClipable()) {
                <agpr-button
                    [id]="id + '_precisionClipButton'"
                    label="Monitor.precisionClip.setup.precisionClip"
                    icon="fa-kit-duotone fa-agpr-ai-generic"
                    [style]="buttonTypesEnum.primary"
                    (click)="openPrecisionClipDialog()"
                ></agpr-button>
            }

            @if (mention.tvEyesArchiveState === tvEyesState.EDITED && !mention.expired) {
                <agpr-button
                    [id]="id + '_revertToOriginalButton'"
                    label="Mention.tveyes.mediaview.revertToOriginal"
                    [style]="buttonTypesEnum.primary"
                    (click)="openRevertDialog()"
                ></agpr-button>
            }

            <agpr-button
                [id]="id + 'closeBtn'"
                label="close"
                (click)="close()"
                [style]="buttonTypesEnum.primary"
            ></agpr-button>
        </ng-template>
    </agpr-dialog-container>

</div>
